module.exports = __webpack_public_path__ + "img/logo35px.385e355a.svg";